'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var scrollTo = function scrollTo(destination) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  var counter = 0;
  destination = document.getElementById(destination);
  var start = window.pageYOffset;
  var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
  var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  if (!destination) return;
  var offset = destination;

  if (typeof offset !== 'number') {
    offset = 0;

    if (destination.offsetParent) {
      offset += destination.offsetParent.offsetTop;
    }

    offset += destination.offsetTop;
  }

  var destinationOffset = offset;
  var topBar = document.querySelector('.top-bar');
  var menuHeight = topBar ? topBar.offsetHeight : 0;
  var subMenu = document.querySelector('.sub-menu');
  var subMenuHeight = subMenu ? subMenu.offsetHeight : 90;
  var menuOffset = menuHeight + subMenuHeight;
  var isLast = documentHeight - destinationOffset < windowHeight - menuOffset;
  var destinationToScroll = Math.round(isLast ? documentHeight - windowHeight : destinationOffset - menuOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationToScroll);
    return;
  }

  var scroll = function scroll() {
    counter++;
    var now = 'now' in window.performance ? performance.now() : new Date().getTime();
    var time = Math.min(1, (now - startTime) / duration);
    window.scroll(0, Math.ceil(time * (destinationToScroll - start) + start));

    if (Math.ceil(window.pageYOffset) === destinationToScroll || counter > 100) {
      return;
    }

    requestAnimationFrame(scroll);
  };

  scroll();
};

var _default = scrollTo;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/scroll-to/index.js
// module id = 663
// module chunks = 0